import { isTypeSeoData } from '@platform/contentful';
import MetaTags from '../util/MetaTags';
import { Entry } from 'contentful';

const ContentfulSeoData = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeSeoData(entry)) {
    return null;
  }
  return (
    <MetaTags
      title={entry.fields.seoTitle}
      description={entry.fields.seoDescription}
      // TODO: There are many more values avaiable on this Contentful type
      // check if they're used/needed
      imageUrl={entry.fields.seoImage?.fields.file?.url}
    />
  );
};

export default ContentfulSeoData;
